var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('TitleHeader',{attrs:{"title":_vm.title}}),_vm._t("default"),_c('div',{staticClass:"last-component"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }